import axios from 'axios';
import config from '../config.js';

// Create axios instance with default configuration
const apiClient = axios.create({
  baseURL: config.BACKEND_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Authentication API
export const authAPI = {
  // Check user permission
  checkUserPermission: async (email) => {
    console.log('API Service - Checking permission for:', email);
    console.log('API Service - Endpoint:', config.ENDPOINTS.CHECK_PERMISSION);
    console.log('API Service - Full URL:', `${config.BACKEND_URL}${config.ENDPOINTS.CHECK_PERMISSION}?email=${email}`);
    
    const response = await apiClient.get(config.ENDPOINTS.CHECK_PERMISSION, {
      params: { email }
    });
    return response.data;
  },

  // Sync user settings
  syncUserSettings: async (email, settings) => {
    const response = await apiClient.put(`/auth/syncSettings/${email}`, settings);
    return response.data;
  }
};

// Email Operations API
export const emailAPI = {
  // Report phishing email
  reportPhishing: async (data) => {
    const response = await apiClient.post(config.ENDPOINTS.REPORT_PHISHING, data);
    return response.data;
  },

  // Forward an email
  forwardEmail: async (data) => {
    const response = await apiClient.post(config.ENDPOINTS.FORWARD_EMAIL, data);
    return response.data;
  },

  // Move an email to a different folder
  moveEmail: async (data) => {
    const response = await apiClient.post(config.ENDPOINTS.MOVE_EMAIL, data);
    return response.data;
  },

  // Delete an email
  deleteEmail: async (data) => {
    const response = await apiClient.post(config.ENDPOINTS.DELETE_EMAIL, data);
    return response.data;
  },

  // Get action logs
  getActionLogs: async (params = {}) => {
    const response = await apiClient.get(config.ENDPOINTS.ACTION_LOGS, { params });
    return response.data;
  },

  // Forward email by add-in (phishing simulation check)
  forwardByAddIn: async (emailData, endpointUrl) => {
    const response = await axios.post(endpointUrl, emailData, {
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  }
};

// Utility functions
export const apiUtils = {
  // Format error message
  formatErrorMessage: (error) => {
    if (error.response?.data?.error) {
      return error.response.data.error;
    }
    if (error.response?.data?.message) {
      return error.response.data.message;
    }
    return error.message || 'An unknown error occurred';
  },

  // Validate required fields
  validateRequiredFields: (data, requiredFields) => {
    const missingFields = requiredFields.filter(field => !data[field]);
    if (missingFields.length > 0) {
      throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }
  }
};

export default {
  authAPI,
  emailAPI,
  apiUtils
};
